import PropTypes from 'prop-types';
import { Edit, useNotify, usePermissions, useRefresh, useTranslate } from 'react-admin';
import { RightDrawer } from '@/components/global/drawers/RightDrawer';
import { RetailChainForm, useRetailChainBrandDrafts } from '@/components/retailChain/forms/RetailChainCreate.jsx';
import { toRetailChainFormValues } from '@/components/retailChain/validators/retailChainValidators.js';

export const RetailChainEdit = ({ handleClose = () => {}, elementId }) => {
    const translate = useTranslate();
    const notify = useNotify();
    const refresh = useRefresh();
    const { permissions } = usePermissions();
    const { brands, saveBrand, removeBrand, transform } = useRetailChainBrandDrafts();

    if (!permissions?.isAdmin) {
        return null;
    }

    return (
        <RightDrawer handleClose={handleClose} title={translate('resources.retailChain.labels.edit')}>
            <Edit
                resource='retail-chain'
                mutationMode='pessimistic'
                id={elementId}
                actions={false}
                transform={transform}
                queryOptions={{
                    select: toRetailChainFormValues,
                }}
                mutationOptions={{
                    onSuccess: () => {
                        notify(translate('resources.retailChain.notifications.updated'));
                        refresh();
                        handleClose();
                    },
                }}
                redirect={false}
            >
                <RetailChainForm handleClose={handleClose} pendingBrands={brands} onSaveBrand={saveBrand} onRemoveBrand={removeBrand} />
            </Edit>
        </RightDrawer>
    );
};

RetailChainEdit.propTypes = {
    handleClose: PropTypes.func,
    elementId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
